import {Component, Input, forwardRef} from '@angular/core';
import {NG_VALUE_ACCESSOR, NG_VALIDATORS} from '@angular/forms';
import {AbstractFieldClass} from '../abstract-field.class';

declare const toastr;

@Component({
    selector: 'directory-unit-array-input-field',
    templateUrl: 'directory-unit-array-input-field.template.html',
    styleUrls: ['./directory-unit-array-input-field.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DirectoryUnitArrayInputFieldComponent), multi: true },
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => DirectoryUnitArrayInputFieldComponent), multi: true }
    ]
})
export class DirectoryUnitArrayInputFieldComponent extends AbstractFieldClass {
    @Input() tooltipText = '';
    @Input() title = '';
    @Input('class') valueClass = '';
    @Input() icon = '';
    @Input() suiteUsers = [];
    @Input() userId = null;

    constructor() {
        super();
    }

    public validator(value): boolean {
        return true;
    }

    apply() {
        let isValid = true;
        this.value.forEach(v => {
            if(!v.fieldValue)
                isValid = false;
            if(this.userId !== null)
                v.user = this.userId;
        });
        if(isValid)
            super.apply();
        else
            toastr.warning('All text fields must be filled');
    }

    addNew() {
        this.value.push({
            fieldValue: '',
            user: null
        });
    }

    editModeOn() {
        if (this.noEdit) return;
        if((this.value && this.value.length == 0) || !this.value) {
            this.value = [{
                fieldValue: '',
                user: null
            }];
        }
        super.editModeOn();
    }

    getUserNameById(id) {
        const suiteUser = this.suiteUsers.find(su => su.user.id == id);
        return suiteUser ? suiteUser.user.fullName : '';
    }

    removeItem(index) {
        this.value.splice(index, 1);
        super.apply();
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/fields/directory-unit-array-input-field/directory-unit-array-input-field.component.ts